<template>
<div class="focused-panel">
  <div class="d-flex lte-toolbar">
    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create LTE" :pressed.sync="addEnabled" variant="primary">
      <icon scale=".6" name="plus" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select LTE" :pressed.sync="selectEnabled" variant="primary">
      <icon scale=".6" name="hand-pointer" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
      <icon scale=".6" name="undo" />
    </b-btn>

    <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Move LTE" :disabled="!wellFeatureSelected || toolDisableValue !== 'Proposed'" :pressed.sync="dragEnabled" variant="primary">
      <icon scale=".6" name="arrows-alt" />
    </b-btn>
    <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
      <icon scale=".6" name="pencil-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete LTEs" :disabled="!wellFeatureSelected" variant="primary">
      <icon scale=".6" name="times" />
    </b-btn>

  </div>
  <b-modal v-model="showForm" @ok="onOK" @cancel="onCancel" size="lg">
    <div slot="modal-header">
      <label>{{formTitle}}</label>
    </div>
    <div class="p-2">
      <b-form>
        <b-row>
          <b-col>
            <b-form-group label="Altname:" label-for="lte-altname">
              <b-form-input id="lte-altname" :state="identState" v-model="wellAttrs['altname']" required placeholder="Enter LTE altname"></b-form-input>
              <b-form-invalid-feedback>
                Well alt name is not unique, change will be ignored
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Description" label-for="lte-description">
              <b-form-input id="lte-description" v-model="wellAttrs['description']" required placeholder="Enter description"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="LTE Type:" label-for="lte-type-select" class="lte-type-select">
              <b-form-select :options="lteTypeOptions" id="lte-type-select" v-model="lteType" required placeholder="Please, select option"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="LTE Status:" label-for="lte-status-select" class="lte-status-select">
              <b-form-select :options="['Proposed', 'Existing']" id="lte-type-select" v-model="wellAttrs['status']" required placeholder="Please, select option"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Comment:" label-for="lteComment">
              <b-textarea id="lteComment" v-model="wellAttrs['comments1']" rows="3"></b-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </b-modal>
</div>
</template>

<script>
import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'

export default {
  name: 'lte-editor',
  components: {},
  mixins: [FeatureEditorMixin],
  data() {
    return {
      geomType: 'Point',
      wellLayerName: 'v4:communication_towers',
      idName: 'objectid_1',
      identName: 'altname',
      geometryName: 'geo',
      lteTypeOptions: [],
      toolDisable: 'status',
      toolDisableValue: null,
      lteType: '',
      wellAttrs: {
        altname: '',
        status: 'Proposed',
        description: '',
        comments1: ''
      },
      schema: 'communication_towers',
      identState: null,
      initialIdent: null
    }
  },
  methods: {
    loadTypes() {
      this.$http.get('/api/layers/lte-type-options').then(res => {
        let fil = res.body.filter(f => f.subject)
        this.lteTypeOptions = fil.map(m => {
          return {
            text: m.subject,
            value: m.id
          }
        })
        this.lteTypeOptions = this.lteTypeOptions.concat({
          text: 'None',
          value: 0
        })
        if (this.wellFeature.get('lib_id')) {
          this.lteType = this.wellFeature.get('lib_id')
        } else {
          this.lteType = 0
        }
      }, res => {
        console.log('Error Thrown')
        console.log(res)
      })
    }
  },
  watch: {
    showForm(val) {
      if (this.lteTypeOptions.length === 0) {
        this.loadTypes()
      } else {
        if (this.wellFeature.get('lib_id')) {
          this.lteType = this.wellFeature.get('lib_id')
        } else {
          this.lteType = 0
        }
      }
    },
    lteType(val) {
      if (val) {
        this.wellFeature.set('lib_id', val)
      }
    },
    wellAttrs: {
      handler(val) {
        if (!this.initialIdent) {
          this.initialIdent = val.altname
        }
        else if (this.initialIdent !== val.altname) {
          let me = this
          this.validateIdent(val.altname)
        } else {
          this.identState = null
        }
      },
      deep: true
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/LteEditor.vue